import styled from 'styled-components';
import {
  color,
  fontSize,
  fontWeight,
  radius,
  screen,
  spacing,
} from '../../../theme';

export const StyledHeroScroll = styled.a`
  display: none;
  flex-direction: column;
  align-items: center;
  margin-top: auto;
  padding-top: ${spacing('sm')};
  color: ${color('text_subtle_inverse')};
  font-size: ${fontSize('xs')};
  font-weight: ${fontWeight('medium')};
  text-transform: uppercase;
  z-index: 1;

  &:hover {
    color: inherit;
  }

  @media (min-width: ${screen('md')}) {
    display: flex;
  }
`;

export const StyledHeroScrollMouse = styled.div`
  position: relative;
  height: 2.5rem;
  width: 1.5rem;
  margin-bottom: ${spacing('xs')};
  border-radius: ${radius('full')};
  border: 2px solid;
`;

export const StyledHeroScrollMouseBall = styled.div`
  position: absolute;
  top: calc(${spacing('sm')} - ${spacing('xs2')} / 2 - 2px);
  left: calc(50% - ${spacing('xs2')} / 2);
  width: ${spacing('xs2')};
  height: ${spacing('xs2')};
  border-radius: ${radius('full')};
  background-color: ${color('text_subtle_inverse')};
  animation: ball 3.5s ease-in-out infinite;

  @keyframes ball {
    0% {
      height: ${spacing('xs2')};
      top: calc(${spacing('sm')} - ${spacing('xs2')} / 2 - 2px);
    }
    30% {
      height: ${spacing('sm')};
      top: calc(${spacing('sm')} - ${spacing('xs2')} / 2 - 2px);
      background-color: ${color('active')};
    }
    50% {
      height: ${spacing('xs2')};
      top: ${spacing('md')};
      background-color: ${color('text_subtle_inverse')};
    }
    75% {
      height: ${spacing('xs2')};
      top: ${spacing('md')};
    }
    100% {
      top: calc(${spacing('sm')} - ${spacing('xs2')} / 2 - 2px);
    }
  }
`;

export const StyledHeroScrollText = styled.div`
  display: flex;
  flex-direction: column;
  text-align: center;

  strong {
    font-weight: ${fontWeight('black')};
    opacity: 0;
    animation: appear 3.5s ease-in-out infinite;

    @keyframes appear {
      40% {
        opacity: 0;
      }
      50% {
        opacity: 1;
      }
      75% {
        opacity: 1;
      }
      100% {
        opacity: 0;
      }
    }
  }
`;
